var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "504.47657pt",
    height: "617.5078pt",
    viewBox: "0 0 504.47657 617.5078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,-53.90234,760.1914)",
    d: "M53.90234 142.6836H558.3789V760.1914H53.90234Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,-53.90234,760.1914)",
    d: "M0 792H612V0H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "Template Scanned Documents.pdf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,50.09766,124.096439)",
    d: "M0 0V-224.586C0-309.509 122.111-444.075 199.175-444.075H200.825C277.889-444.075 400-309.509 400-224.586V0 4.841C400 63.208 364.366 75.925 200.825 75.925H199.175C35.634 75.925 0 63.208 0 4.841",
    fill: "#5e6db3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,50.09766,124.096439)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0V-224.586C0-309.509 122.111-444.075 199.175-444.075H200.825C277.889-444.075 400-309.509 400-224.586V0 4.841C400 63.208 364.366 75.925 200.825 75.925H199.175C35.634 75.925 0 63.208 0 4.841"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,-53.90234,760.1914)",
    d: "M213.977 280.54H193.977V680.54006H213.977Z",
    fill: "#f2f2f3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,364.46125,397.7473)",
    d: "M0 0V-22.763H-153.8V318.096H-133.8V0Z",
    fill: "#f2f2f3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,25.09766,354.5018)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0V250"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,-53.90234,760.1914)",
    d: "M264.562 282.526H418.365V302.526H264.562Z",
    fill: "#f2f2f3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,250.09766,19.984986)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0C-184.746 0-225-14.156-225-79.128"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,25.09766,354.5018)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0C0-94.534 137.944-244.327 225-244.327"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,476.9626,354.5018)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0V250"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,251.96256,19.984986)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0C184.746 0 225-14.156 225-79.128"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,476.9626,354.5018)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#5e6db3",
    d: "M0 0C0-94.534-137.944-244.327-225-244.327"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91541b77f17018ba8ad182c54d0e2e54.svg";
export { ForwardRef as ReactComponent };